import moment from "moment";

interface FormValues {
  quarryName: string;
  quarryId: string;
  phone: string;
  addressField: string;
  accountTerms: string;
  accountLimit: string;
  notes: string;
  addressData: {
    lat: number;
    lng: number;
    address: string;
  };
  mondayStartTime?: string;
  mondayEndTime?: string;
  tuesdayStartTime?: string;
  tuesdayEndTime?: string;
  wednesdayStartTime?: string;
  wednesdayEndTime?: string;
  thursdayStartTime?: string;
  thursdayEndTime?: string;
  fridayStartTime?: string;
  fridayEndTime?: string;
  saturdayStartTime?: string;
  saturdayEndTime?: string;
  sundayStartTime?: string;
  sundayEndTime?: string;
  notes?: string;
  addressLat?: number;
  addressLng?: number;
  accountTermsCustom: string;
  disableCoordinates?: boolean;
}

interface DaySwitchVals {
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

interface QuarryData {
  id: string;
  quarryName: string;
  quarryId: number;
  address: string;
  coordinates: string;
  lat: number;
  lng: number;
  openingHours: OpeningHour[];
  phone: string;
  currentBalance: string;
  overdueBalance: string;
  lifeTimePurchases: string;
  last3Months: string;
  last30Days: string;
  accountLimit: string;
  accountTerms: string;
  enableCoordinates: boolean;
}

interface OpeningHour {
  day: string;
  open?: string;
  close?: string;
  closed?: boolean;
}

interface APIResponse {
  data: QuarryData;
}

export function convertToFormValuesAndDaySwitchVals(apiResponse: APIResponse): {
  formValues: FormValues;
  daySwitchVals: DaySwitchVals;
} {
  const { data } = apiResponse;
  const formValues: FormValues = {
    quarryName: data.quarryName,
    quarryId: String(data.quarryId),
    phone: data.phone,
    addressField: data.address,
    accountTerms: data.accountTerms,
    accountLimit: data.accountLimit,
    notes: data.notes,
    addressData: {
      lat: data.lat,
      lng: data.lng,
      address: data.address,
    },
    addressLat: data.lat,
    addressLng: data.lng,
    disableCoordinates: data.enableCoordinates,
  };

  const daySwitchVals: DaySwitchVals = {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  };

  data?.openingHours?.forEach((hour) => {
    const day = hour?.day?.toLowerCase() as keyof DaySwitchVals;
    if (hour?.closed) {
      daySwitchVals[day] = false;
    } else {
      daySwitchVals[day] = true;
      (formValues as any)[`${day}StartTime`] = hour?.open;
      (formValues as any)[`${day}EndTime`] = hour?.close;
    }
  });

  return { formValues, daySwitchVals };
}

export const FILTER_FIELD_NAMES_TO_COUNT = [
  "materialType",
  "category",
  "address",
] as const;
